import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import {catchError, defaultIfEmpty, map, Observable, of, take, timeout} from 'rxjs';
import {buildPath} from '@utils/util-builder';
import {matchesProviderHotelScope, positiveRouteIdentity} from './provider-hotel-scope';

@Injectable({providedIn: 'root'})
export class MasterProviderHotelAccessGuard implements CanActivate {
    constructor(private readonly http: HttpClient, private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const denied = this.router.parseUrl('/404-not-found');
        const hotelId = positiveRouteIdentity(route.paramMap.get('hotelId'));
        if (hotelId === null) return of(denied);
        // This protected endpoint enforces both roles0/5 and server-owned semiMaster hotel scope.
        return this.http.get<unknown>(buildPath([
            'data-core/Hotel/Master/getProvidersInfo', String(hotelId)
        ])).pipe(
            take(1),
            timeout(5000),
            map(response => matchesProviderHotelScope(response, hotelId) ? true : denied),
            defaultIfEmpty(denied),
            catchError(() => of(denied))
        );
    }
}
